import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "semantic-ui-react";

import * as actions from "../../actions";
import TrelloForm from "./TrelloForm";
import ProjectBreadcrumb from "../breadcrumb/ProjectBreadcrumb";
import StandardTableHeader from "../UI/StandardHeader";

const TrelloCreate = ({
  match: {
    params: { orderid },
  },
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchTrello(orderid));
    dispatch(actions.fetchFiles());

    return () => {
      dispatch(actions.unloadTrello());
    };
  }, []);

  const [searchValue, setSearchValue] = useState("");

  const trello = useSelector((state) => state.trellos.item);
  const creating = useSelector((state) => state.trellos.creating);
  const projectid = useSelector((state) => state.orders.projectID);
  const responsemessage = useSelector((state) => state.trellos.responsemessage);
  const showmessage = useSelector((state) => state.trellos.showmessage);
  const files = useSelector((state) => state.files.items);
  const projectFiles = useSelector((state) => state.projectFiles.items);

  const onSubmit = (fv) => {
    dispatch(actions.createTrello(fv));
  };

  if (!orderid || !projectid) {
    return <div>No valid orderid or projectid...</div>;
  }

  const init = { ...trello };

  return (
    <React.Fragment>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <StandardTableHeader headerLabel="Send To Trello">
              <ProjectBreadcrumb projectID={projectid} currentPath="Trello" />
            </StandardTableHeader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <h4>Order: {orderid}</h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <TrelloForm
              enableReinitialize={true}
              initialValues={init}
              onSubmit={onSubmit}
              files={files}
              projectFiles={projectFiles}
              downloadFile={(filename) =>
                dispatch(actions.downloadFile(filename))
              }
              downloadProjectFile={(projectid, filename) =>
                dispatch(actions.downloadProjectFile(projectid, filename))
              }
              showmessage={showmessage}
              resetTrelloMessage={() => dispatch(actions.resetTrelloMessage())}
              responsemessage={responsemessage}
              projectid={projectid}
              searchValue={searchValue}
              updatesearchValue={(evt) => setSearchValue(evt.target.value)}
              creating={creating}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

export default TrelloCreate;
